import { render, staticRenderFns } from "./IdentificationDocumentFinancialSponsor.vue?vue&type=template&id=09fe9db5&scoped=true&"
import script from "./IdentificationDocumentFinancialSponsor.vue?vue&type=script&lang=ts&"
export * from "./IdentificationDocumentFinancialSponsor.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationDocumentFinancialSponsor.vue?vue&type=style&index=0&id=09fe9db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe9db5",
  null
  
)

export default component.exports